import React from 'react';

import { Flex } from '@chakra-ui/react';
import {
  Button,
  ChevronDown,
  Dropdown,
  DropdownContent,
  DropdownItem,
  DropdownSub,
  DropdownTrigger,
  DropdownSubTrigger,
  DropdownPortal,
} from '@mesh.ai/rabbit';

import { Publish } from 'assets/assetsV1/iconComponents';

import { TextBodyMedium } from 'uiToolkitV1/Typography';

import type { BulkActionOptionsType } from './BulkActionHeader';

interface Props {
  isDisabled: boolean;
  options: BulkActionOptionsType[];
}

export const BulkActionsSplitButton = ({ options, isDisabled }: Props) => {
  if (options?.length > 1) {
    return (
      <Dropdown>
        <DropdownTrigger asChild>
          <Button iconRight={ChevronDown} disabled={isDisabled}>
            Actions
          </Button>
        </DropdownTrigger>
        <DropdownContent>
          {options?.map((option) => {
            if (option.isSubMenu) {
              return (
                <DropdownSub key={option.label}>
                  <DropdownSubTrigger style={{ width: '100%' }}>
                    <Flex key={option.label} alignItems="center">
                      {option.icon && <option.icon />}
                      <TextBodyMedium ml="8px">{option.label}</TextBodyMedium>
                    </Flex>
                  </DropdownSubTrigger>
                  <DropdownPortal>
                    <DropdownContent side="left">
                      {option.subActions.map((subOption) => (
                        <DropdownItem key={subOption.label} onSelect={() => subOption.onClick?.()}>
                          <Flex key={subOption.label} alignItems="center">
                            <TextBodyMedium ml="8px">{subOption.label}</TextBodyMedium>
                          </Flex>
                        </DropdownItem>
                      ))}
                    </DropdownContent>
                  </DropdownPortal>
                </DropdownSub>
              );
            }

            return (
              <DropdownItem key={option.label} onSelect={() => option.onClick?.()}>
                <Flex key={option.label} alignItems="center">
                  {option.icon && <option.icon />}
                  <TextBodyMedium ml="8px">{option.label}</TextBodyMedium>
                </Flex>
              </DropdownItem>
            );
          })}
        </DropdownContent>
      </Dropdown>
    );
  }

  return (
    <Button
      disabled={isDisabled}
      iconLeft={() => <Publish boxSize="24px" color="#FFFFFF" />}
      onClick={options[0].onClick}
    >
      {options[0].label}
    </Button>
  );
};
